import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRegUser, FaUserAlt } from 'react-icons/fa';
import { Menu, Button, MenuItem } from '@mui/material';

import '../assets/css/header.css';
import SearchBox from './SearchBox';

function Header({ onRefillClick, isAuthenticated, onLogout, cart }) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [searchTerm, setSearchTerm] = useState(localStorage.getItem('selectedLocation') || '');
    const [inputValue, setInputValue] = useState(() => safeParse(localStorage.getItem('selectedLocation')) || '');
    const [selectedLocation, setSelectedLocation] = useState(() => safeParse(localStorage.getItem('selectedLocation')) || '');
    const [userLocation, setUserLocation] = useState(null);
    const [prescription, setPrescription] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [activeIcon, setActiveIcon] = useState('home');
  
    const [userData, setUserData] = useState(() => {
        const storedData = localStorage.getItem('user_data');
        try {
            return storedData ? JSON.parse(storedData) : null;
        } catch (error) {
            console.error('Error parsing user_data from localStorage:', error);
            return null;
        }
    });
    const cartLength = cart?.length || 0;


    const handleOpen = () => setOpenModal(true);
    const handleCloseModal = () => {
        setOpenModal(false);
        setPrescription(null);
        setUploadStatus('');
    };

    /* REMOVED: the debounce-and-navigate pair that used to live here.
     *
     * It pushed /search-result/<term> on every 400ms pause in typing, so one
     * word could stack several history entries and the back button had to be
     * pressed repeatedly to get out. Clearing the box navigated to the home
     * page, throwing away whatever the person was reading. And it redirected
     * signed-out visitors to /login, even though the same visitor could already
     * browse every product and price on the site.
     *
     * SearchBox now fetches suggestions as you type and navigates only when you
     * choose something. */


    function safeParse(value) {
        try {
            return JSON.parse(value);
        } catch {
            return value;
        }
    }

    function userLogOut() {
        setAnchorEl(null);
        if (window.confirm('Are you sure you want to logout?')) {
            localStorage.removeItem('user_data');
            setUserData(null);
            navigate('/');
            onLogout();
        }
    }


    /*function handleSearch(e) {
        e.preventDefault(); // Prevent page reload
        if (!searchInput.trim()) return;
        navigate(`/search-result/${encodeURIComponent(searchInput)}`);
    }*/
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleIconClick = (icon) => {
        setActiveIcon(icon);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function toggleMenu() {
        setShowMenu(!showMenu);
    }
    return (
        <>
            <header className="header">
                <div className="header-container">
                    {/* ------- LEFT SECTION ------- */}
                    <div className="header-left">
                        <a className="logo" href="/">
                            <div className="logo-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M12 2c3.866 0 7 3.134 7 7 0 5-7 11-7 11s-7-6-7-11c0-3.866 3.134-7 7-7z"
                                        fill="white"
                                    />
                                    <path
                                        d="M11 7h2v4h4v2h-4v4h-2v-4H7v-2h4V7z"
                                        fill="white"
                                    />
                                </svg>
                            </div>
                            <span className="logo-text">MVL Pharmacy</span>
                        </a>

                        {/* Search, with suggestions. No longer gated on sign-in:
                            the catalogue is public and the Store API needs no
                            credential, so requiring a login to search hid the
                            shop from anyone who did not already know what it
                            stocked. See SearchBox for the other two problems it
                            replaced. */}
                        <SearchBox />
                    </div>

                    {/* ------- RIGHT SECTION ------- */}
                    <div className="header-right">

                        <button
                            className="btn btn-green"
                            onClick={onRefillClick}
                            style={{ border: "none", background: "var(--mv-green)", cursor: "pointer" }}
                        >
                            Refill Prescription
                        </button>

                        <a className="cart-btn" onClick={() => navigate('/cart')}  style={{cursor:'pointer'}}>
                            <span className="cart-icon">🛒</span>
                            <span>Cart</span>
                        </a>

                        <a className="contact-link" href="/contact">Contact</a>

                        {isAuthenticated ? (
                            <div>
                                <Button
                                    id="basic-button"
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                >
                                    <FaUserAlt style={{ color: 'black' }} />
                                    <span style={{ fontSize: '14px', padding: '2px 0 0 5px', color: 'black' }}>
                                        {userData?.name}
                                    </span>
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >
                                    <MenuItem onClick={() => { setAnchorEl(null); navigate('/account'); }}>Profile</MenuItem>
                                    <MenuItem onClick={() => { setAnchorEl(null); navigate('/my-orders'); }}>My orders</MenuItem>
                                    <MenuItem onClick={() => { setAnchorEl(null); navigate('/my-prescription'); }}>My prescription</MenuItem>
                                    <MenuItem onClick={userLogOut}>Logout</MenuItem>
                                </Menu>
                            </div>
                        ) : (
                            <div className="d-flex" style={{ width: '115px', margin: '-2px 0 0', cursor: 'pointer' }}>
                                <FaUserAlt style={{ margin: '2px 0 0' }} />
                                <span style={{ fontSize: '14px' }} onClick={() => navigate('/login')}>
                                    Login / Signup
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;
